module.exports = __webpack_public_path__ + "img/start1.7e701c4.png";